import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/dashboard/balance/long-term-assets",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
